const translations = {
    cancel: 'Cancel',
    certificateOfAuthorizationNumber: 'Certificate of Authorization Number',
    faaDocketNumber: 'FAA Docket Number',
    faaExemptionNumber: 'FAA Exemption Number',
    invalidCoa:
        'Invalid Certificate of Authorization Number (COA), This field cannot contain spaces or special characters.',
    invalidFaaDocketNumber: 'Invalid Exemption Docket Number. Example: FAA-1234-5678',
    invalidFaaExemptionNumber: 'Invalid Exemption Number. Example: ABC123',
    maximumExceeded: 'Too many characters',
    save: 'Save',
    saveError: 'Certifications could not be saved.',
    saving: 'Saving…',
    title: 'Edit Certifications & Exemptions'
};

export default translations;
